import { render, staticRenderFns } from "./NubanAccounts.vue?vue&type=template&id=82a39310&scoped=true"
import script from "./NubanAccounts.vue?vue&type=script&lang=js"
export * from "./NubanAccounts.vue?vue&type=script&lang=js"
import style0 from "./NubanAccounts.vue?vue&type=style&index=0&id=82a39310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a39310",
  null
  
)

export default component.exports